import { render, staticRenderFns } from "./ChangeButton.vue?vue&type=template&id=131bad52&"
import script from "./ChangeButton.vue?vue&type=script&lang=js&"
export * from "./ChangeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports